 
import React from 'react'
import AdvertisementImage from './AdvertisementImage'
import getAdvertisementImgKeyArray from '../functions/getAdvertisementImgKeyArray'


const AdvertisementImages = ({images, imageURLs, imgTag = false}) => {
    const imgKeyArray = getAdvertisementImgKeyArray(imageURLs, images)

    return (
        <div className="custom-placement-image-container">
            {imgKeyArray.map(key => imageURLs[key] && <AdvertisementImage
                key={key}
                imgKey={key}
                imgURL={imageURLs[key]}
                imgTag={imgTag}
            
            />)}
        </div>
    )
}

export default AdvertisementImages